import {AnyAction, Reducer} from 'redux';
import {AuthorPollUtil, Questions, StoreActionsEnum} from '../../../modules/hbs-services';

export const questionsReducer: Reducer<Questions> = (state = null, action: AnyAction = null) => {

    switch (action.type) {

        // entire poll
        case StoreActionsEnum.ENTIRE_POLL_LOADED:
        case StoreActionsEnum.POLL_INSERTED: {
            const questions = AuthorPollUtil.getQuestionsExt(action.payload);
            return questions;
        }

        case StoreActionsEnum.QUESTIONS_UPDATED:
            return action.payload.questions;

        // questions and scriptQuestSets
        case StoreActionsEnum.ALL_QUESTIONS_AND_SCRIPTQUESTSETS_REPLACED:
        case StoreActionsEnum.QUESTIONS_DELETED: {
            const questions = action.payload.questions;
            // if (questions && action.payload.select) {
            //     questions['select'] = action.payload.select;
            // }
            return questions;
        }

        case StoreActionsEnum.POLL_DELETED:
        case StoreActionsEnum.RESET_POLL:
            return null;

        default:
            return state;
    }
};
